import { CloseOutlined, Facebook, InfoOutlined, Instagram, Link, LinkedIn, PersonOutlined, YouTube, Pinterest, Textsms, PhotoCamera, Groups } from '@mui/icons-material';
import React from 'react';
import { IMartialIcon } from '../interfaces/IMaterialIcon';

const CmsMaterialPredefinedIcon : React.FC<IMartialIcon> = ({icon}) => {
    return <>
        {icon === "reddit" && <Groups />}
        {icon === "pinterest" && <Pinterest />}
        {icon === "flickr" && <PhotoCamera />}
        {icon === "snapchat" && <Textsms />}
        {icon === "instagram" && <Instagram />}
        {icon === "facebook" && <Facebook />}
        {icon === "youtube" && <YouTube />}
        {icon === "linkedin" && <LinkedIn />}
        {icon === "xing" && <Link />}
        {icon === "link" && <Link />}
        {icon === "close" && <CloseOutlined />}
        {icon === "profile" && <PersonOutlined />}
        {icon === "info" && <InfoOutlined />}
    </>
}

export default CmsMaterialPredefinedIcon;